import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _MODAL_COMPONENTS;

import React from 'react';
import Form from './Form';
import Confirmation from './Confirmation';
import DeleteConfirmation from './DeleteConfirmation';
import WEB_CAM from './WebCam';
import Iframe from './Iframe';
export var TYPES = {
  DELETE_CONFIRMATION: 'DELETE_CONFIRMATION',
  PROMPT_INPUT: 'PROMPT_INPUT',
  WEB_CAM: 'WEB_CAM',
  TEST_EMAIL_SETTINGS: 'TEST_EMAIL_SETTINGS',
  VERIFY_EMAIL_SETTINGS: 'VERIFY_EMAIL_SETTINGS',
  TRACKER_EMAIL_SETTINGS: 'TRACKER_EMAIL_SETTINGS',
  TRACKER_EMAIL_CODE: 'TRACKER_EMAIL_CODE',
  CONFIRMATION: 'CONFIRMATION',
  ASK_QUESTION: 'ASK_QUESTION',
  REMOVE_INTEGRATION: 'REMOVE_INTEGRATION',
  MANAGE_SUBSCRIPTION: 'MANAGE_SUBSCRIPTION',
  FORM: 'FORM',
  IFRAME: 'IFRAME',
  MOVE_CONTACTS_TO_TOUCHPOINT: 'MOVE_CONTACTS_TO_TOUCHPOINT'
};
/**@type {{[key: string]: React.ComponentType<object>}} */

export var MODAL_COMPONENTS = (_MODAL_COMPONENTS = {}, _defineProperty(_MODAL_COMPONENTS, TYPES.FORM, Form), _defineProperty(_MODAL_COMPONENTS, TYPES.IFRAME, Iframe), _defineProperty(_MODAL_COMPONENTS, TYPES.CONFIRMATION, Confirmation), _defineProperty(_MODAL_COMPONENTS, TYPES.WEB_CAM, WEB_CAM), _defineProperty(_MODAL_COMPONENTS, TYPES.DELETE_CONFIRMATION, DeleteConfirmation), _defineProperty(_MODAL_COMPONENTS, TYPES.PROMPT_INPUT, React.lazy(function () {
  return import('./PromptInput');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.TEST_EMAIL_SETTINGS, React.lazy(function () {
  return import('../../page/Settings/Email/Components/Test');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.TRACKER_EMAIL_SETTINGS, React.lazy(function () {
  return import('../../page/Settings/Tracking/Tracker');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.TRACKER_EMAIL_CODE, React.lazy(function () {
  return import('../../page/Settings/Tracking/TrackingCode');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.VERIFY_EMAIL_SETTINGS, React.lazy(function () {
  return import('../../page/Settings/Email/Components//Verify');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.REMOVE_INTEGRATION, React.lazy(function () {
  return import('../../page/Settings/Integrations/CRM/RemoveIntegration');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.ASK_QUESTION, React.lazy(function () {
  return import('./AskQuestion');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.MANAGE_SUBSCRIPTION, React.lazy(function () {
  return import('./ManageSubscription');
})), _defineProperty(_MODAL_COMPONENTS, TYPES.MOVE_CONTACTS_TO_TOUCHPOINT, React.lazy(function () {
  return import('./MoveContactsToTouchpoint');
})), _MODAL_COMPONENTS);
export default MODAL_COMPONENTS;